/**
 * API Configuration
 * Centralized configuration for all API endpoints
 */

export const API_CONFIG = {
  BASE_URL: 'https://api.cryptmet.com/api',
  JS_GAMES_BASE_URL: 'https://api.cryptmet.com/jsGames', // For fetching games (like old code)
  JS_GAMES_V2_BASE_URL: 'https://api.cryptmet.com/jsGamesv2', // For launching games
};

/**
 * Get full API URL
 * @param {string} endpoint - API endpoint (e.g., '/gis/gamesgis' or '/leaderboard?type=all')
 * @returns {string} Full API URL
 */
export const getApiUrl = (endpoint) => {
  // Remove leading slash if present
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_CONFIG.BASE_URL}/${cleanEndpoint}`;
};

/**
 * Get JS Games API URL (for fetching games)
 * @param {string} endpoint - API endpoint (e.g., '/games?vendor=pragmatic')
 * @returns {string} Full JS Games API URL
 */
export const getJsGamesUrl = (endpoint) => {
  // Remove leading slash if present
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_CONFIG.JS_GAMES_BASE_URL}/${cleanEndpoint}`;
};

/**
 * Get JS Games V2 API URL (for launching games)
 * @param {string} endpoint - API endpoint (e.g., '/launch')
 * @returns {string} Full JS Games V2 API URL
 */
export const getJsGamesV2Url = (endpoint) => {
  // Remove leading slash if present
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_CONFIG.JS_GAMES_V2_BASE_URL}/${cleanEndpoint}`;
};
